/**
 * A key for one submit of a request the server runs once per key: random, so two submits never
 * share one, and printable, as the server asks.
 */
export const newIdempotencyKey = () => {
  const cryptoApi = typeof window !== 'undefined' ? window.crypto : null;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  if (cryptoApi?.getRandomValues) {
    return Array.from(cryptoApi.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0')).join('');
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
};
